import { render } from "./User-address-form.vue?vue&type=template&id=1d5af888&scoped=true"
import script from "./User-address-form.vue?vue&type=script&lang=js"
export * from "./User-address-form.vue?vue&type=script&lang=js"

import "./User-address-form.vue?vue&type=style&index=0&id=1d5af888&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d5af888"]])

export default __exports__